import React from 'react';

/**
 * Renders `text` with accent substring(s) wrapped for brand emphasis.
 * `accent` may be a string or an array of strings (applied in order).
 */
export function MarketingHeadlineAccent({ text, accent, className = 'marketing-headline-accent' }) {
  if (!text) return null;

  const accents = Array.isArray(accent)
    ? accent.filter((a) => a != null && a !== '')
    : accent
      ? [accent]
      : [];

  if (!accents.length) return <>{text}</>;

  const renderSegment = (segment, accentIndex) => {
    if (typeof segment !== 'string') return segment;
    if (accentIndex >= accents.length) return segment;

    const current = accents[accentIndex];
    if (!current || !segment.includes(current)) {
      return renderSegment(segment, accentIndex + 1);
    }

    const parts = segment.split(current);
    return parts.map((part, i) => (
      <React.Fragment key={`${accentIndex}-${i}`}>
        {i > 0 ? <span className={className}>{current}</span> : null}
        {renderSegment(part, accentIndex + 1)}
      </React.Fragment>
    ));
  };

  return <>{renderSegment(text, 0)}</>;
}
